<template>
  <div class="about-landing" v-once>

    <section class="section intro">
      <div class="container">
        <div class="row">
          <div class="col-md-5 white text-sm-left">
            <h1 class="m-t-0 m-b-lg">The LogBox Story</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-a">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-offset-3 text-left">
            <h1 class="m-b-lg">In the beginning</h1>
            <div>
              <p class="lead">LogBox was founded in 2010 by an orthopaedic surgeon who wanted to change the way things were done. </p>

              <p>LogBox simplifies everybody’s life – from the <a href="#/patient">patient</a> to the <a href="#/practice">healthcare professional </a> to the <a href="#/academic">trainee doctor</a>.
					Admin is a part of life, but it doesn’t add any value, only plenty of time and frustration. LogBox was designed by doctors who understand the value of people
					and their time, and who understand the needs of healthcare professionals, the healthcare industry and their patients.</p>

              <p>LogBox improves the connections between people and healthcare professionals and is part of our commitment to creating user-friendly and intelligent clinical
						solutions which leverage modern technology to inspire collaboration and transformation. </p>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="section section-b">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-offset-3 text-left">
            <h1 class="m-b-lg">A good start</h1>
            <div>
              <p>Even before its official launch, LogBox was piloted at the Wits Donald Gordon Medical Centre and registered more than 5,000 patients.
						It was also nominated as a finalist in the MTN Business App of the Year Awards when it was only three months old. </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-c">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-offset-3 text-left">
            <h1 class="m-b-lg">Big brother</h1>
            <div>
              <p class="lead">EPI-USE is a company founded in South Africa with offices in 22 countries.</p>

              <p>The company has been building a successful track record in bespoke
							software application development since its inception in 1984 and has been involved in a large number of successful, custom software engineering
							projects ever since, spanning industries like Telecommunications, Energy, Insurance, Mining, Oil & Gas, Government, Insurance, Education, and
							Healthcare; in both local and international markets. EPI-USE's software application development capability is traded under the 'Advance' brand.</p>

              <p>More information can be found at <a href="http://www.advance.io">www.advance.io</a>.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section class="section section-d">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-md-offset-3 text-left">
            <h1 class="m-b-lg">A secure solution</h1>
            <div>
              <p class="lead">Privacy and security is at the heart of the LogBox products, which is why we take every precaution to secure and protect the personal and health information of each patient.</p>
              <p>Security concerns are addressed on every level from application infrastructure and authentication to data encryption. Your information is not shared with anyone without your consent.</p>
              <p>LogBox is Protection of Personal Information (POPI) compliant.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section class="">
      <div class="container-fluid">
        <div class="row flush">
          <div class="col-md-4 grey-1">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Patient</h3>
              <p class="">LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.</p>
              <router-link to="/patient" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-2">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Practice</h3>
              <p class="">Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.</p>
              <router-link to="/practice" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
          <div class="col-md-4 grey-3">
            <div class="p-a-lg">
              <h3 class="m-t-0 m-b">LogBox Academic</h3>
              <p class="">A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.</p>
              <router-link to="/academic" class="btn btn-default">Learn More</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PartnerBranding from 'components/common/PartnerBranding';

  export default {
    name: 'about',
    components: {
      PartnerBranding,
    },
  };

</script>



// WEBPACK FOOTER //
// About.vue?562992a2